module.exports = __webpack_public_path__ + "static/media/wonderly_logo_big.9b3e28b1.png";